import Vue from 'vue';
import VueAnalytics from 'vue-ua';
import App from './App.vue';
import store from './store';

import './assets/styles/index.css';

Vue.use(VueAnalytics, {
  // [Required] The name of your app as specified in Google Analytics.
  appName: 'Skoolie Layout',
  // [Required] The version of your app.
  appVersion: '1.0',
  // [Required] Your Google Analytics tracking ID.
  trackingId: 'UA-84468069-14',
})

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    sanitizeText: function (name) {
      name = name.toLowerCase();
      name = name.replace(/[\s]/g, '-');
      name = name.replace(/[^a-z0-9_-]/g, '');
      return name;
    }
  }
});

new Vue({
  store,
  render: h => h(App),
}).$mount('#app');
